import React from "react";
import { Route, Routes, useMatch } from "react-router-dom";
import GroupView from "./views/group";
import Brand from "./views/brand";
import Outlet from "./views/outlet";
import "../style.scss";
import { useAppContext } from "../../../../AppContext";

function Group() {
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  // Get the base path using useMatch
  const match = useMatch("/app/group/*");
  const basePath = match ? `/${match.pathname.split("/")[1]}` : "/app/group";

  const routes = [
    {
      name: "Group",
      path: "main/:page?/:id?",
      component: GroupView,
    },
    {
      name: "Brand",
      path: "brand/:page?/:id?",
      component: Brand,
    },
    {
      name: "Outlet",
      path: "outlet/:page?/:id?",
      component: Outlet,
    },
  ];

  return (
    <div className="viewContainer">
      <Routes>
        <Route
          path={"main/:page?/:id?"}
          element={
            <GroupView
              user={props.user}
              chimeraserv={props.chimeraserv}
              components={props.components}
            />
          }
        />
        <Route
          path={"brand/:page?/:id?"}
          element={
            <Brand
              user={props.user}
              chimeraserv={props.chimeraserv}
              components={props.components}
            />
          }
        />
        <Route
          path={"outlet/:page?/:id?"}
          element={
            <Outlet
              user={props.user}
              chimeraserv={props.chimeraserv}
              components={props.components}
            />
          }
        />
        <Route
          path="*"
          element={
            props.components.setting[0].component
              ? React.createElement(props.components.setting[0].component)
              : null
          }
        />
      </Routes>
    </div>
  );
}
export default Group;
